var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"third-url",on:{"touchmove":function($event){$event.stopPropagation();}}},[_c('iframe',{attrs:{"id":"modle_iframe","src":_vm.thirdUrl,"frameborder":"0","scrolling":"yes"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }